import { TextResources, ConfigData } from '../config/StoreLocatorTextResources';
import { IMAGEVIEW } from '../services/imageview.service';
import { HOURS } from '../services/opening.hours.service';

export class Templates {
  constructor() {
    this.locationObjKeyaccId = undefined;
    this.productBlock = undefined;
  }

  createSingleLocation(locationObj) {
    let output = '';

    output = '<cwc-location id="' + locationObj['loc_id'] + '">';
    output += '<div class="info-content">';

    output +=
      '<button class="back-to-locations"><span class="icon-arrow-left red"></span><span>' +
      TextResources.resources.location.control.back_results +
      '</span></button>';
    output += !locationObj['name'] ? '' : '<h3>' + locationObj['name'] + '</h3>';
    output += '<div class="address"><span class="icon icon-location"></span><div>';
    output += !locationObj['street'] ? '' : locationObj['street'] + ',<br />';
    output +=
      !locationObj['zip'] || !locationObj['city'] ? '' : locationObj['zip'] + ', ' + locationObj['city'] + '<br />';
    //output += !locationObj['opening_hours'] ? '' : HOURS.getStoreHours(locationObj['opening_hours']);
    output +=
      '<div class="store-distance" style="font-weight: bold;"><span id="store-distance">' +
      locationObj['distance'] +
      '</span> km ' +
      TextResources.resources.location.distance +
      '</div>';
    output += '<cwc-button-itinerary></cwc-button-itinerary>';
    output += '<cwc-order-at-home></cwc-order-at-home>';
    output += '</div></div>';

    //If keyaccount present in blacklist, the phone field will be disabled
    if (
      locationObj['phone'] !== undefined &&
      !ConfigData.data.phoneDisabled &&
      this.isNotBlacklisted(ConfigData.data.phoneBlacklist, locationObj['loc_id'])
    ) {
      output +=
        '<div class="phone"><span class="icon icon-phone"></span><div><a href="tel:' +
        locationObj['phone'] +
        '" target="_parent"><span>' +
        locationObj['phone'] +
        '</span></a></div></div>';
    }

    if (locationObj['opening_hours']) {
      output += '<div class="hours"><span class="icon icon-clock"></span><div>';

      for (let val of Object.entries(locationObj['opening_hours'])) {
        val = val[1];
        const today = val['day'].toUpperCase() == HOURS.getToday().toUpperCase() ? true : false;
        if (val['status'].toUpperCase() == 'OPEN' && today) {
          output +=
            '<div style="font-weight: bold;">' +
            this.getWeekdayName(val['day']) +
            ' ' +
            val['open'] +
            ' - ' +
            val['close'] +
            '</div>';
        } else if (val['status'].toUpperCase() == 'OPEN') {
          output += '<div>' + this.getWeekdayName(val['day']) + ' ' + val['open'] + ' - ' + val['close'] + '</div>';
        } else {
          const style = today ? ' style="font-weight: bold;"' : '';
          const hours =
            today || (val['open'] === '00:00' && val['close'] === '00:00')
              ? ' <span>' + this.getStoreStatus(val['status']) + '</span>'
              : ' ' + val['open'] + ' - ' + val['close'];
          output += '<div' + style + '>' + this.getWeekdayName(val['day']) + hours + '</div>';
        }
      }
      output += '</div></div>';
    }

    output += '</div>';

    output += IMAGEVIEW.getLocationImagesItems(locationObj);
    output += this.getLocationItinerary(locationObj);
    output += this.getShemaOrgJsonLD(locationObj);
    //console.log('obj: ', locationObj);

    output += '</cwc-location>';

    return output;
  }

  createMultipleLocations(locationObj) {
    let output = '';

    output = '<cwc-location id="' + locationObj['loc_id'] + '">';

    output += '<cwc-location-info><div class="info-content">';
    output += !locationObj['name'] ? '' : '<h3>' + locationObj['name'] + '</h3>';

    output += '<p>';
    output += !locationObj['street'] ? '' : locationObj['street'] + ', ';
    output +=
      !locationObj['zip'] || !locationObj['city'] ? '' : locationObj['zip'] + ', ' + locationObj['city'] + '<br>';
    output += !locationObj['opening_hours'] ? '' : HOURS.getStoreHours(locationObj['opening_hours']);
    output +=
      '<span><span id="store-distance">' +
      locationObj['distance'] +
      '</span> km ' +
      TextResources.resources.location.distance +
      '</span>';

    output += '<div class="all-products">';
    output +=
      '   <span id="prod-canvas">' +
      ('prod_canvas' in locationObj ? locationObj['prod_canvas'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-photos-strip">' +
      ('prod_photos_strip' in locationObj ? locationObj['prod_photos_strip'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-greeting-cards">' +
      ('prod_greeting_cards' in locationObj ? locationObj['prod_greeting_cards'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-collages">' +
      ('prod_collages' in locationObj ? locationObj['prod_collages'] : 'NO') +
      '</span><br>';
    output +=
      '   <span id="prod-photo-sets">' +
      ('prod_photo_sets' in locationObj ? locationObj['prod_photo_sets'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-multipart-photos">' +
      ('prod_multipart_photos' in locationObj ? locationObj['prod_multipart_photos'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-retro-minis">' +
      ('prod_retro_minis' in locationObj ? locationObj['prod_retro_minis'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-stickers">' +
      ('prod_stickers' in locationObj ? locationObj['prod_stickers'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-product-labels">' +
      ('prod_product_labels' in locationObj ? locationObj['prod_product_labels'] : 'NO') +
      '</span></br>';
    output +=
      '   <span id="prod-photos">' + ('prod_photos' in locationObj ? locationObj['prod_photos'] : 'NO') + '</span><br>';
    output +=
      '   <span id="prod-photos-frame">' +
      ('prod_photos_frame' in locationObj ? locationObj['prod_photos_frame'] : 'NO') +
      '</span><br>';
    output +=
      '   <span id="prod-poster">' + ('prod_poster' in locationObj ? locationObj['prod_poster'] : 'NO') + '</span><br>';
    output +=
      '   <span id="prod-passfoto">' +
      ('prod_passfoto' in locationObj ? locationObj['prod_passfoto'] : 'NO') +
      '</span><br>';
    output += '</div>';
    output += '</p>';
    output += '<p class="more-info">' + TextResources.resources.location.more_info + '</p>';
    output += '</div>';
    //output += '<div class="button-itinerary" id="button-itinerary-menu"><span class="icon icon-distribute"></span>' + TextResources.resources.location.control.calculate_route + '</div>';
    output += '</cwc-location-info>';

    output += this.getLocationItinerary(locationObj);
    output += this.getLocationDetails_Sidebar(locationObj);
    output += this.getShemaOrgJsonLD(locationObj);

    output += '</cwc-location>';

    return output;
  }

  // Sidebar Template: Location Itinerary (Route)
  getLocationItinerary(locationObj) {
    let output = '';
    output += '<cwc-location-itinerary>';

    output += '<h3>' + TextResources.resources.location.route_to_station + '</h3>';
    output +=
      '<div><input id="destination-input' +
      locationObj['loc_id'] +
      '" class="itinerary-controls" type="text" value="' +
      locationObj['latitude'] +
      ',' +
      locationObj['longitude'] +
      '" hidden/></div>';

    output += '<div id="mode-selector" class="itinerary-controls">';
    output += '<input type="radio" name="route" id="driving' + locationObj['loc_id'] + '" checked>';
    output += '<label for="driving' + locationObj['loc_id'] + '"><i class="fa fa-car" aria-hidden="true"></i></label>';
    output += '<input type="radio" name="route" id="transit' + locationObj['loc_id'] + '" >';
    output +=
      '<label for="transit' + locationObj['loc_id'] + '"><i class="fa fa-subway" aria-hidden="true"></i></label>';
    output += '<input type="radio" name="route" id="walking' + locationObj['loc_id'] + '">';
    output +=
      '<label for="walking' +
      locationObj['loc_id'] +
      '"><i class="fa-solid fa-person-walking" aria-hidden="true"></i></label>';
    output += '<input type="radio" name="route" id="bicycling' + locationObj['loc_id'] + '">';
    output +=
      '<label for="bicycling' + locationObj['loc_id'] + '"><i class="fa fa-bicycle" aria-hidden="true"></i></label>';
    output += '</div>';

    output +=
      '<div id="directionsPanel' +
      locationObj['loc_id'] +
      '" class="directions-panel" style="float:left;height:100%"></div>';

    output += '</cwc-location-itinerary>';

    return output;
  }

  // Sidebar Template: Location Details
  getLocationDetails_Sidebar(locationObj) {
    let output = '';

    output += '<cwc-location-details>';
    output += '<div class="cover-image"><img src="' + TextResources.resources.location.cover_image + '"></div>';
    output += '<div class="details-list">';

    output += '<div class="store-info"><div class="info-content">';
    output += !locationObj['name'] ? '' : '<h3>' + locationObj['name'] + '</h3>';
    output += '<p>';
    output += !locationObj['street'] ? '' : locationObj['street'] + ', ';
    output +=
      !locationObj['zip'] || !locationObj['city'] ? '' : locationObj['zip'] + ', ' + locationObj['city'] + '</br>';
    output += !locationObj['opening_hours'] ? '' : HOURS.getStoreHours(locationObj['opening_hours']);
    output += '<span>' + locationObj['distance'] + ' km ' + TextResources.resources.location.distance + '</span>';
    output += '</p></div>';
    output +=
      '<div class="button-itinerary"><span class="icon icon-distribute"></span>' +
      TextResources.resources.location.control.calculate_route +
      '</div>';
    output += '</div>';
    output += '<div class="store-details">';

    //If keyaccount present in blacklist, the phone field will be disabled
    if (
      locationObj['phone'] !== undefined &&
      !ConfigData.data.phoneDisabled &&
      this.isNotBlacklisted(ConfigData.data.phoneBlacklist, locationObj['loc_id'])
    ) {
      output +=
        '<div class="phone"><span class="icon icon-phone"></span><a href="tel:' +
        locationObj['phone'] +
        '" target="_parent"><span>' +
        locationObj['phone'] +
        '</span></a></div>';
    }

    if (locationObj['opening_hours']) {
      output += '<div class="hours">';
      output +=
        '<div class="accordion"><span class="icon icon-clock"></span><span>' +
        TextResources.resources.location.opening_hours +
        '</span><span class="icon right icon-arrow-down"></span></div>';
      output += '<div class="panel"></br>';

      for (let val of Object.entries(locationObj['opening_hours'])) {
        output += '<div class="opening-hours' + locationObj['loc_id'] + '">';
        val = val[1];
        const today = val['day'].toUpperCase() == HOURS.getToday().toUpperCase() ? true : false;
        if (val['status'].toUpperCase() == 'OPEN' && val['day'].toUpperCase() == HOURS.getToday().toUpperCase()) {
          output +=
            '<span style="font-weight: bold;" id="day' +
            val['day'].toUpperCase() +
            '">' +
            this.getWeekdayName(val['day']) +
            '</span>';
          output +=
            '<span style="font-weight: bold;" id="hour' +
            val['day'].toUpperCase() +
            '"><div id="open' +
            val['day'].toUpperCase() +
            '">' +
            val['open'] +
            '</div>  -  <div id="close' +
            val['day'].toUpperCase() +
            '">' +
            val['close'] +
            '</div></span>';
        } else if (val['status'].toUpperCase() == 'OPEN') {
          output += '<span id="day' + val['day'].toUpperCase() + '">' + this.getWeekdayName(val['day']) + '</span>';
          output +=
            '<span id="hour' +
            val['day'].toUpperCase() +
            '"><div id="open' +
            val['day'].toUpperCase() +
            '">' +
            val['open'] +
            '</div>  -  <div id="close' +
            val['day'].toUpperCase() +
            '">' +
            val['close'] +
            '</div></span>';
        } else {
          const style = today ? ' style="font-weight: bold;"' : '';
          const hours =
            today || (val['open'] === '00:00' && val['close'] === '00:00')
              ? this.getStoreStatus(val['status'])
              : ' ' + val['open'] + ' - ' + val['close'];
          output +=
            '<span' +
            style +
            ' id="day' +
            val['day'].toUpperCase() +
            '">' +
            this.getWeekdayName(val['day']) +
            '</span>';
          output += '<span' + style + '>' + hours + '</span>';
        }
        output += '</div>';
      }
      output += '</div></div>';
    }

    output += '<div class="products">';
    output +=
      '<div class="accordion"><span class="icon icon-info"></span><span>' +
      TextResources.resources.location.onsite_products +
      '</span><span class="icon right icon-arrow-down"></span></div>';
    output += '<div class="panel">';
    output += !locationObj['prod_photos']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.photos.headline +
        '</h3><span>' +
        TextResources.resources.productData.photos.description +
        '</span>';
    output += !locationObj['prod_photos_frame']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.photos_frame.headline +
        '</h3><span>' +
        TextResources.resources.productData.photos_frame.description +
        '</span>';
    output += !locationObj['prod_poster']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.poster.headline +
        '</h3><span>' +
        TextResources.resources.productData.poster.description +
        '</span>';
    output += !locationObj['prod_photos_strip']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.photos_strip.headline +
        '</h3><span>' +
        TextResources.resources.productData.photos_strip.description +
        '</span>';
    output += !locationObj['prod_greeting_cards']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.greeting_cards.headline +
        '</h3><span>' +
        TextResources.resources.productData.greeting_cards.description +
        '</span>';
    output += !locationObj['prod_collages']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.collages.headline +
        '</h3><span>' +
        TextResources.resources.productData.collages.description +
        '</span>';
    output += !locationObj['prod_photo_sets']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.photo_sets.headline +
        '</h3><span>' +
        TextResources.resources.productData.photo_sets.description +
        '</span>';
    output += !locationObj['prod_multipart_photos']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.multipart_photos.headline +
        '</h3><span>' +
        TextResources.resources.productData.multipart_photos.description +
        '</span>';
    output += !locationObj['prod_retro_minis']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.retro_minis.headline +
        '</h3><span>' +
        TextResources.resources.productData.retro_minis.description +
        '</span>';
    output += !locationObj['prod_stickers']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.stickers.headline +
        '</h3><span>' +
        TextResources.resources.productData.stickers.description +
        '</span>';
    output += !locationObj['prod_product_labels']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.product_labels.headline +
        '</h3><span>' +
        TextResources.resources.productData.product_labels.description +
        '</span>';
    output += !locationObj['prod_canvas']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.canvas.headline +
        '</h3><span>' +
        TextResources.resources.productData.canvas.description +
        '</span>';
    output += !locationObj['prod_passfoto']
      ? ''
      : '<h3>' +
        TextResources.resources.productData.passfoto.headline +
        '</h3><span>' +
        TextResources.resources.productData.passfoto.description +
        '</span>';
    output += '</div>';
    output += '</div>';
    output += '</div>';

    output += '<div class="product_images">';
    output += '<div><h3>' + TextResources.resources.location.products_variety + '</h3></div>';
    output += '<div class="img-items-wrapper">';
    output += '<div class="img-items-slider">';
    output += '<div class="img-items">';
    output += !locationObj['prod_photos']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_photos_frame']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_frame.images[0] +
        '"></picture></div><div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_frame.images[1] +
        '"></picture></div><div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_frame.images[2] +
        '"></picture></div>';
    output += !locationObj['prod_poster']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.poster.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_photos_strip']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_strip.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_greeting_cards']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.greeting_cards.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_collages']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.collages.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_photo_sets']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photo_sets.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_multipart_photos']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.multipart_photos.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_retro_minis']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.retro_minis.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_stickers']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.stickers.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_product_labels']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.product_labels.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_canvas']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.canvas.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_passfoto']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.passfoto.images[0] +
        '"></picture></div>';
    output += '</div>';
    output += '</div>';
    output += '<div class="button">' + TextResources.resources.location.control.img_show_more + '</div>';
    output += '</div>';
    output += '</div>';

    output += '</div>';

    output += '<cwc-order-at-home></cwc-order-at-home>';
    output += '</cwc-location-details>';

    return output;
  }

  getFilterTemplate() {
    let output = '';

    output +=
      '<div class="accordion"><span>' +
      TextResources.resources.filter.headline +
      '</span><span class="icon right icon-arrow-down"></span>';
    output += '</div>';
    output += '<div class="panel">';
    if (this.productBlock === undefined) {
      output += '<span>' + TextResources.resources.filter.nothing_to_filter + '</span>';
    } else {
      output += this.productBlock;
    }
    output += '<div class="stores">' + '<span id="info-stores-found" class="stores-found"></span>' + '</div>';
    output +=
      '<div class="reset">' +
      '<a id="btn-reset-filters" class="sg-cw-button sg-cw-raise sg-cw-light">' +
      TextResources.resources.filter.filter_reset +
      '</a>' +
      '</div>';

    return output;
  }

  getFilterProductTemplate(secondClass, prodId, prodLabel) {
    const output =
      '<div class="filter-item' +
      secondClass +
      '"><input type="checkbox" id="' +
      prodId +
      '" name="filter" value="' +
      prodLabel +
      '" /><label for="' +
      prodId +
      '">' +
      prodLabel +
      '</label></div>';

    return output;
  }

  getWeekdayName(shortname) {
    return TextResources.resources.weekdays[shortname];
  }

  getStoreStatus(status) {
    const statusResource = status === open ? 'status_open' : 'status_closed';
    return TextResources.resources.location[statusResource];
  }

  getImagesItem(item) {
    const output = '<div class="img-item"><picture><img src="' + item + '"></picture></div>';
    return output;
  }

  getProductImages(locationObj) {
    let output = '';

    output += !locationObj['prod_photos']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_photos_frame']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_frame.images[0] +
        '"></picture></div><div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_frame.images[1] +
        '"></picture></div><div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_frame.images[2] +
        '"></picture></div>';
    output += !locationObj['prod_poster']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.poster.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_photos_strip']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photos_strip.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_greeting_cards']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.greeting_cards.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_collages']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.collages.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_photo_sets']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.photo_sets.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_multipart_photos']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.multipart_photos.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_retro_minis']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.retro_minis.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_stickers']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.stickers.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_product_labels']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.product_labels.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_canvas']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.canvas.images[0] +
        '"></picture></div>';
    output += !locationObj['prod_passfoto']
      ? ''
      : '<div class="img-item"><picture><img src="' +
        TextResources.resources.productData.passfoto.images[0] +
        '"></picture></div>';

    return output;
  }

  /**
   * Checked whether the element is in the blacklist
   * @param {Array} blackList
   * @param {String} itemId
   * @returns
   */
  isNotBlacklisted(blackList, itemId) {
    if (blackList && blackList.indexOf(Number(itemId)) > -1) {
      return false;
    }
    return true;
  }

  getShemaOrgJsonLD(locationObj) {
    let output = '';

    output += `
  <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "place",
      "name": "${locationObj.name}",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "${locationObj.street}",
        "addressLocality": "${locationObj.city}",
        "postalCode": "${locationObj.zip}",
        "addressCountry": "${locationObj.iso_country}"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": ${locationObj.latitude},
        "longitude": ${locationObj.longitude}
      }`;
    if (locationObj['phone']) {
      output += `,
      "telephone": "${locationObj.phone}"`;
    }
    if (locationObj['opening_hours']) {
      output += `,
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Monday",
          "opens": "${locationObj.opening_hours[0].open}",
          "closes": "${locationObj.opening_hours[0].close}"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Tuesday",
          "opens": "${locationObj.opening_hours[1].open}",
          "closes": "${locationObj.opening_hours[1].close}"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Wednesday",
          "opens": "${locationObj.opening_hours[2].open}",
          "closes": "${locationObj.opening_hours[2].close}"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Thursday",
          "opens": "${locationObj.opening_hours[3].open}",
          "closes": "${locationObj.opening_hours[3].close}"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Friday",
          "opens": "${locationObj.opening_hours[4].open}",
          "closes": "${locationObj.opening_hours[4].close}"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "${locationObj.opening_hours[5].open}",
          "closes": "${locationObj.opening_hours[5].close}"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Sunday",
          "opens": "${locationObj.opening_hours[6].open}",
          "closes": "${locationObj.opening_hours[6].close}"
        }
      ]
      `;
    }
    output += `
    }
</script>
    `;

    return output;
  }
}

export const TEMPLATE = new Templates();
